import React from 'react'

export const CrossIcon: React.FC = () => (
  <svg viewBox='0 0 27 27' fill='currentColor' xmlns='http://www.w3.org/2000/svg'>
    <path d='M2 2L25 25' stroke='currentColor' strokeWidth='3' strokeLinecap='round' />
    <path d='M2 25L25 2' stroke='currentColor' strokeWidth='3' strokeLinecap='round' />
  </svg>
)
